import { clientAxios } from '@/plugins/axios'
import format from 'string-format'

const baseURL = '/v1/delivery'
const getDeliveryMethodLink = `${baseURL}/{postal_code}/delivery-method`
const getDeliveryDateMinLink = `${baseURL}/{id}/delivery-date/{postal_code}/start/{pref_id}`
const getDeliveryDetailLink = `${baseURL}/detail/{id}`
const getDeliveryCheckRemoteLink = `${baseURL}/check-remote-island`

export const deliveryMethod = () =>
  clientAxios.get(baseURL, {
    params: {
      visible: true,
    },
  })
export const deliveryMethodDetail = (id) => clientAxios.get(`${baseURL}/${id}/time`)
export const getDeliveryMethod = (postal_code) => clientAxios.get(format(getDeliveryMethodLink, { postal_code }))
export const getDeliveryDateMin = ({ id, pref_id, postal_code }) =>
  clientAxios.get(format(getDeliveryDateMinLink, { id, pref_id, postal_code }))
export const getDeliveryDetail = (id) => clientAxios.get(format(getDeliveryDetailLink, { id }))
export const checkNotBundledRemoteIsland = (params) => clientAxios.get(getDeliveryCheckRemoteLink, { params })
